

// export default AboutServices;
import React, { useEffect, useContext } from "react";
import AboutUserIcon from "../images/About_User_Icon.png";
import { AppContext } from "../Context/Provider";
import LazyLoad from "react-lazyload";

const AboutServices = () => {
  const { FetchAboutServiceDetail, AboutServiceDetailsData } =
    useContext(AppContext);

  useEffect(() => {
    FetchAboutServiceDetail();
  }, []);

  return (
    <>
      {/* About Services Section */}
      <section className="py-16 bg-gray-100 font-poppins px-4 md:px-6 lg:px-8 mt-80 md:mt-32 lg:mt-48">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {AboutServiceDetailsData.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow p-6 transition-transform hover:scale-[1.01]"
              >
                <div className="flex items-center mb-4">
                  <span className="inline-block bg-green-100 text-xs px-2 py-1 rounded-lg">
                    <span className="text-yellow-400">★</span> 4.8
                  </span>
                </div>
                <h3 className="text-xl font-bold text-custom-green mb-2">
                  {service.title}
                </h3>
                <div className="flex items-center mb-2">
                  <LazyLoad height={20} offset={100}>
                    <img
                      src={AboutUserIcon}
                      width="20"
                      alt="User Icon"
                      className="mr-2"
                    />
                  </LazyLoad>
                  <span>{service.count}</span>
                </div>
                <p className="text-gray-600 text-sm md:text-base">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Career Section */}
      <section className="bg-[#F0F5FF] py-16 md:py-20 px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-start gap-10">
          {/* Left Column: Video + Text */}
          <div className="w-full lg:w-1/2">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Accelerate your career
            </h2>
            <p className="text-gray-600 mb-8 text-base md:text-lg">
              We have proven methods that work for more than 7 years to help our
              client's business grow.
            </p>
            <div className="w-full aspect-video">
              <iframe
                className="w-full h-full rounded"
                src="https://www.youtube.com/embed/aqKcNdAl8Oc?si=JTdRJvQ8N2CTr3da"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            </div>
          </div>

          {/* Right Column: Highlights */}
          <div className="w-full lg:w-1/2 space-y-6">
            {[
              {
                number: 1,
                title: "Speed and Scale",
                description:
                  "We move fast. It took us only 12 months to launch Dhaweeye Food across all regions of Somaliland, while Dhaweey Drive was launched in a short period",
              },
              {
                number: 2,
                title: "Impact",
                description:
                  "We empower people to take initiative and fully own their responsibilities. As a result, they can make a continuous impact on one of the largest areas.",
              },
              {
                number: 3,
                title: "Opportunities",
                description:
                  "As the company grows, new opportunities emerge. We encourage our people to take on challenges so they can advance in their careers.",
              },
            ].map((item, index) => (
              <div key={index} className="flex items-start space-x-4">
                <div className="bg-gray-800 text-white rounded-full w-12 h-12 flex items-center justify-center text-lg font-semibold">
                  {item.number}
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm md:text-base">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutServices;
